// src/web/lib/router.ts
// Holds a reference to the TanStack Router instance so non-React code
// (e.g. toast click handlers) can perform SPA navigation without a full reload.

import type { AnyRouter } from '@tanstack/react-router'

let _router: AnyRouter | null = null

/** Call once after createRouter() in main.tsx */
export function setRouterInstance(router: AnyRouter) {
	_router = router
}

/** SPA-navigate to `path`. Falls back to window.location for safety. */
export function navigateTo(path: string) {
	if (_router) {
		_router.navigate({ to: path })
	} else {
		window.location.href = path
	}
}
